<template>
    <div class="validation" v-if="turnaround && numberWords > 0">
        <p>We're sorry but your document has {{numberWords}} {{wordPage}} which is too many {{wordPage}} for your selected turnaround speed. Please see our {{wordPage}} limits below and choose a turnaround speed that is accepted.</p>
        <ul>
            <li>Please email us for documents over {{maxLimit}} {{wordPage}}</li>
            <li
            v-for="turnaround in turnarounds"
            :key="turnaround.key">
                {{ turnaround.FriendlyName }} turnaround {{ wordLimit(turnaround) }} {{wordPage}} limit
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        turnaround: [Object, Boolean],
        turnarounds: [Array, Boolean],
        numberWords: [Number, Boolean, String],
        SelectedData: Object,
        CheckoutData: Object,
    },
    methods : {
        wordLimit(turnaround) {
            let WordLimit = parseInt(turnaround.WordLimit);
            if(this.SelectedData.expertise == 'Certified') {
                WordLimit = parseInt(turnaround.wordLimitCertified); 
            } else if(this.CheckoutData.specialTurnarounds.includes(turnaround.ID) || this.CheckoutData.inhouseTurnarounds.includes(turnaround.ID)) {
                WordLimit = parseInt(turnaround.wordLimitInhouse); 
            }
            return WordLimit;
        }
    },
    computed: {
        maxLimit() {
            const turnaround = this.CheckoutData.turnarounds[0];
            let WordLimit = parseInt(turnaround.WordLimit);
            if(this.SelectedData.expertise == 'Certified') {
                WordLimit = parseInt(turnaround.wordLimitCertified); 
            } else if(this.CheckoutData.specialTurnarounds.includes(turnaround.ID) || this.CheckoutData.inhouseTurnarounds.includes(turnaround.ID)) {
                WordLimit = parseInt(turnaround.wordLimitInhouse); 
            }
            return WordLimit;
        },
        wordPage() {
            if(this.SelectedData.expertise == 'Certified') {
                return 'pages';
            }
            return 'words';
        }
    }
}
</script>